// extracted by mini-css-extract-plugin
module.exports = {"average-rating":"styles_average-rating__2S1TY styles_average-rating__2S1TY","overview-banner":"styles_overview-banner__2MrG9"};